import {
  arrayBufferDownload,
  arrayBufferDownloadExcel,
  downloadCSV,
} from "../../../../utils/download";
import {
  decorateEmptyGridValues,
  setColumnDefaultExtraProps,
} from "../../../../utils/table/gridUtils";
import { DATE_STRATEGY } from "../../../../utils/date";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_RESERVATIONS_RESERVATIONS_LIST,
  TOAST,
  FETCH_RESERVATIONS_RESERVATIONS_INIT,
  FETCH_RESERVATIONS_RESERVATIONS_DETAIL,
  EXPORT_RESERVATIONS_RESERVATIONS,
  CREATE_RESERVATIONS_RESERVATIONS,
  SEARCH_RESERVATIONS_RESERVATIONS,
  EDIT_RESERVATIONS_RESERVATIONS,
  INIT_CREATE_RESERVATIONS_RESERVATIONS_SCREEN,
  RESERVATIONS_RESERVATIONSDD,
  RESERVATIONS_RESERVATIONSDELETE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  SEND_CONFIRMATION_EMAIL,
  SET_RESERVATION_FILTERS,
  CLEAR_RESERVATION_FILTERS,
  SET_TABLE_COLUMN_FILTERS,
  CLEAR_TABLE_COLUMN_FILTERS,
  SAVE_RESERVATION_TABLE_STATE,
  SYNC_TO_SOFIAC,
  FETCH_SOFIAC_RESERVATION_STATUS,
} from "../../../types/Reservations/Reservations.type";
import { getCurrentAndThreeDaysLater } from "../../../../utils";

const formFieldValueMap = {
  id: null,
  addId: 0,
  addVal: 0,
  address: "",
  airportConcessionFee: 0,
  airportFacilityChargeTotal: 0,
  beforeTax: 0,
  cardExpiry: "",
  categoryId: 0,
  creditCardNumber: "",
  cvv: "",
  days: 0,
  dppId: 0,
  dppVal: 0,
  driverAge: 0,
  dropOffDate: "",
  dropOffTime: "",
  emId: 0,
  emVal: 0,
  emailId: "",
  fees: 0,
  firstName: "",
  flightDetails: "",
  gtId: 0,
  gtVal: 0,
  lastName: "",
  locationAfterHourFee: 0,
  locationAfterHourDropoffFee: 0,
  locationId: 0,
  nameOnCard: "",
  netDailyRate: 0,
  oopId: 0,
  oopVal: 0,
  payNow: 0,
  phoneNumber: "",
  pickUpDate: "",
  pickUpTime: "",
  remainderHours: 0,
  reservationEquipmentList: [],
  reservationSearchRequest: "",
  taxAmountDiscount: 0,
  totalAmount: 0,
  type: "",
};

const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();

const INITIAL_STATE = {
  ReservationsReservationsListview: [],
  ReservationsReservationsDD: [],
  isReservationsReservationsDDSuccess: false,
  isReservationsReservationsDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isReservationsReservationsCreateSuccess: false,
  isReservationsReservationsCreateError: false,
  isReservationsReservationsSearchSuccess: false,
  isReservationsReservationsSearchError: false,
  isReservationsReservationsDetailSuccess: false,
  isReservationsReservationsDetailError: false,
  isReservationsReservationsEditSuccess: false,
  isReservationsReservationsEditError: false,
  isReservationsReservationsExportSuccess: false,
  isReservationsReservationsExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  isReservationsReservationsDeleteSuccess: false,
  isReservationsReservationsDeleteError: false,
  isSendConfirmationEmailSuccess: false,
  isSendConfirmationEmailError: false,
  isSyncToSofiacSuccess: false,
  isSyncToSofiacError: false,
  sofiacReservationStatus: null,
  isSofiacReservationStatusSuccess: false,
  isSofiacReservationStatusError: false,
  reservationFilters: {
    endDate: threeDaysLater,
    startDate: currentDate,
    location: "",
    network: "",
    status: 0,
    type: "pickupDate",
  },
  tableColumnFilters: {},
  reservationSummary: null,
  savedTableState: null,
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      id,
      ref,
      networkTitle,
      locationTitle,
      vehicle,
      bookingDate,
      pickup,
      dropoff,
      currencyCode,
      totalAmount,
      days,
      name,
      paymentStatus,
      rateType,
      status,
    } = item;

    const transformedValues = {
      id,
      ref,
      networkTitle,
      locationTitle,
      vehicle,
      bookingDate,
      pickup,
      dropoff,
      currencyCode,
      totalAmount,
      days,
      name,
      paymentStatus,
      rateType,
      status,
      noShowAction: status,
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Res#",
      dataKey: "ref",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
      },
      style: { minWidth: "140px" },
    },
    {
      colLabel: "Network",
      dataKey: "networkTitle",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
        defaultVisible: false,
      },
      style: { minWidth: "160px" },
    },

    {
      colLabel: "Location",
      dataKey: "locationTitle",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
        defaultVisible: false,
      },
    },
    {
      colLabel: "Vehicle",
      dataKey: "vehicle",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
      },
    },
    {
      colLabel: "Booking Date",
      dataKey: "bookingDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        strategy: DATE_STRATEGY.DATE_TIME_ISO_AMPM,
        selectable: true,
      },
      style: { minWidth: '180px' },
    },
    {
      colLabel: "Pickup Date",
      dataKey: "pickup",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        strategy: "DATE_ISO",
        selectable: true,
      },
      style: { minWidth: '180px' },
    },

    {
      colLabel: "Dropoff Date",
      dataKey: "dropoff",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        strategy: "DATE_ISO",
        selectable: true,
      },
      style: { minWidth: '180px' },
    },
    {
      colLabel: "Days",
      dataKey: "days",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...", 
        selectable: true,
        defaultVisible: false,
      },
    },
    {
      colLabel: "Total",
      dataKey: "totalAmount",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
      },
    },
    {
      colLabel: "Currency",
      dataKey: "currencyCode",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
        defaultVisible: false,
      },
    },
    {
      colLabel: "Name",
      dataKey: "name",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
      },
    },
    {
      colLabel: "Payment Status",
      dataKey: "paymentStatus",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
        defaultVisible: false,
      },
    },
    {
      colLabel: "Rate Type",
      dataKey: "rateType",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: true,
        defaultVisible: false,
      },
    },

    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
        selectable: false,
      },
    },
    {
      colLabel: "No Show",
      dataKey: "noShowAction",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        isNoShowColumn: true,
        selectable: true,
        defaultVisible: false,
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const ReservationsReservationsReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case FETCH_RESERVATIONS_RESERVATIONS_INIT:
      return {
        ...state,
        ReservationsReservationsListview: [],
        isLoading: false,
        isLoadingPage: true,
        error: null,
        isReservationsReservationsCreateSuccess: false,
        isReservationsReservationsCreateError: false,
        isReservationsReservationsSearchSuccess: false,
        isReservationsReservationsSearchError: false,
        isReservationsReservationsDetailSuccess: false,
        isReservationsReservationsDetailError: false,
        isReservationsReservationsEditSuccess: false,
        isReservationsReservationsEditError: false,
        isReservationsReservationsExportSuccess: false,
        isReservationsReservationsExportError: false,
        isSendConfirmationEmailSuccess: false,
        isSendConfirmationEmailError: false,
        sofiacReservationStatus: null,
        isSofiacReservationStatusSuccess: false,
        isSofiacReservationStatusError: false,
        // Explicitly preserve filters and table state
        reservationFilters: state.reservationFilters,
        tableColumnFilters: state.tableColumnFilters,
        savedTableState: state.savedTableState,
      };
    case FETCH_RESERVATIONS_RESERVATIONS_DETAIL.START:
    case EXPORT_RESERVATIONS_RESERVATIONS.START:
    case UPLOAD_IMAGE.START:
    case FETCH_RESERVATIONS_RESERVATIONS_LIST.START:
    case CREATE_RESERVATIONS_RESERVATIONS.START:
    case SEARCH_RESERVATIONS_RESERVATIONS.START:
    case RESERVATIONS_RESERVATIONSDELETE.START:
    case EDIT_RESERVATIONS_RESERVATIONS.START:
    case RESERVATIONS_RESERVATIONSDD.START:
    case SEND_CONFIRMATION_EMAIL.START:
    case SYNC_TO_SOFIAC.START:
    case FETCH_SOFIAC_RESERVATION_STATUS.START:
      return { ...state, isLoading: true };

    case FETCH_RESERVATIONS_RESERVATIONS_LIST.SUCCESS: {
      //const { page, data } = action.payload;
      const { page, data, reservationSummary } = action.payload?.data;
      let resetState = {
        ...state,
        ReservationsReservationsListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isReservationsReservationsCreateSuccess: false,
        isReservationsReservationsCreateError: false,
        reservationSummary: null,
      };
      if (!data) {
        return { ...resetState, reservationFilters: state.reservationFilters };
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        reservationFilters: state.reservationFilters,
        ReservationsReservationsListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
        reservationSummary: reservationSummary || null,
      };
    }
    case FETCH_RESERVATIONS_RESERVATIONS_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        ReservationsReservationsListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isReservationsReservationsDeletionSuccess: false,
        isReservationsReservationsDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_RESERVATIONS_RESERVATIONS_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isReservationsReservationsDetailSuccess: true,
      };
    }
    case FETCH_RESERVATIONS_RESERVATIONS_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isReservationsReservationsDetailSuccess: false,
        isReservationsReservationsDetailError: true,
      };
    }

    //DD
    case RESERVATIONS_RESERVATIONSDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        ReservationsReservationsDD: temp,
        isReservationsReservationsDDSuccess: true,
        isReservationsReservationsDDError: false,
      };
    }
    case RESERVATIONS_RESERVATIONSDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isReservationsReservationsDDSuccess: false,
        isReservationsReservationsDDError: true,
      };
    }
    //END DD
    //DELETE

    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY: {
      const shouldOpenDeleteConfirmationPopup = action.payload;
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup,
        isReservationsReservationsDeleteSuccess: false,
        isReservationsReservationsDeleteError: false,
      };
    }
    case RESERVATIONS_RESERVATIONSDELETE.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        isReservationsReservationsDeleteSuccess: true,
        isReservationsReservationsDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case RESERVATIONS_RESERVATIONSDELETE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isReservationsReservationsDeleteSuccess: false,
        isReservationsReservationsDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    //END DD

    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_RESERVATIONS_RESERVATIONS.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isReservationsReservationsExportSuccess: false,
        isReservationsReservationsExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_RESERVATIONS_RESERVATIONS.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "reservations.xls");
      return {
        ...state,
        isLoading: false,
        isReservationsReservationsExportSuccess: true,
        isReservationsReservationsExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_RESERVATIONS_RESERVATIONS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isReservationsReservationsEditSuccess: false,
        isReservationsReservationsEditError: true,
      };
    }

    case EDIT_RESERVATIONS_RESERVATIONS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isReservationsReservationsEditSuccess: true,
        isReservationsReservationsEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_RESERVATIONS_RESERVATIONS_SCREEN: {
      return { 
        ...INITIAL_STATE, 
        reservationFilters: state.reservationFilters,
        tableColumnFilters: state.tableColumnFilters,
        savedTableState: state.savedTableState,
      };
    }

    case CREATE_RESERVATIONS_RESERVATIONS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isReservationsReservationsCreateSuccess: false,
        isReservationsReservationsCreateError: true,
      };
    }
    case CREATE_RESERVATIONS_RESERVATIONS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isReservationsReservationsCreateSuccess: true,
        isReservationsReservationsCreateError: false,
      };
    }

    //End
    // SEARCH

    case SEARCH_RESERVATIONS_RESERVATIONS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isReservationsReservationsSearchSuccess: false,
        isReservationsReservationsSearchError: true,
      };
    }
    case SEARCH_RESERVATIONS_RESERVATIONS.SUCCESS: {
      const temp = action.payload?.data;
      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isReservationsReservationsSearchSuccess: true,
        isReservationsReservationsSearchError: false,
      };
    }

    case SEND_CONFIRMATION_EMAIL.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSendConfirmationEmailSuccess: true,
        isSendConfirmationEmailError: false,
      };
    }

    case SEND_CONFIRMATION_EMAIL.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isSendConfirmationEmailSuccess: false,
        isSendConfirmationEmailError: true,
      };
    }
    // End Send Confirmation Email

    // Sync To Sofiac
    case SYNC_TO_SOFIAC.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSyncToSofiacSuccess: true,
        isSyncToSofiacError: false,
      };
    }

    case SYNC_TO_SOFIAC.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isSyncToSofiacSuccess: false,
        isSyncToSofiacError: true,
      };
    }
    // End Sync To Sofiac

    case FETCH_SOFIAC_RESERVATION_STATUS.SUCCESS: {
      return {
        ...state,
        sofiacReservationStatus: action.payload,
        isLoading: false,
        isSofiacReservationStatusSuccess: true,
        isSofiacReservationStatusError: false,
      };
    }

    case FETCH_SOFIAC_RESERVATION_STATUS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        sofiacReservationStatus: null,
        isLoading: false,
        isSofiacReservationStatusSuccess: false,
        isSofiacReservationStatusError: true,
      };
    }

    case TOAST.RESET: {
      return {
        ...state,
        isReservationsReservationsCreateSuccess: false,
        isReservationsReservationsCreateError: false,
        isReservationsReservationsEditError: false,
        isReservationsReservationsEditSuccess: false,
        isReservationsReservationsDetailError: false,
        isReservationsReservationsSearchSuccess: false,
        isReservationsReservationsSearchError: false,
        isSendConfirmationEmailSuccess: false,
        isSendConfirmationEmailError: false,
        isSyncToSofiacSuccess: false,
        isSyncToSofiacError: false,
      };
    }

    case SET_RESERVATION_FILTERS: {
      return {
        ...state,
        reservationFilters: action.payload.filters,
      };
    }

    case CLEAR_RESERVATION_FILTERS: {
      const { currentDate: newCurrentDate, threeDaysLater: newThreeDaysLater } = getCurrentAndThreeDaysLater();
      return {
        ...state,
        reservationFilters: {
          endDate: newThreeDaysLater,
          startDate: newCurrentDate,
          location: "",
          network: "",
          status: 0,
          type: "pickupDate",
        },
      };
    }

    case SET_TABLE_COLUMN_FILTERS: {
      return {
        ...state,
        tableColumnFilters: action.payload.filters,
      };
    }

    case CLEAR_TABLE_COLUMN_FILTERS: {
      return {
        ...state,
        tableColumnFilters: {},
      };
    }

    case SAVE_RESERVATION_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

    default:
      return state;
  }
};
